import { LoginDriver, LoginExped } from "@/store/apis/nextcargo";

function isLoginDriverResult(value: LoginDriver["result"] | LoginExped["result"]): value is LoginDriver["result"] {
  return typeof value === "object" && value !== null && "name" in value;
}

function isLoginExpedResult(value: LoginDriver["result"] | LoginExped["result"]): value is LoginExped["result"] {
  return typeof value === "object" && value !== null && "user" in value;
}

export { isLoginDriverResult, isLoginExpedResult };
